import { IApplicationState } from '../../types/redux';

export function getInstagram(state: IApplicationState) {
  return state.developer.instagram;
}
